export default __webpack_public_path__ + "static/media/resume.42adc9e4.pdf";